module.exports = __webpack_public_path__ + "img/cooperate_jr_03@2x.78087cf2.png";